import React, { useEffect, useState } from 'react';
import { FillControl } from '../../shared/ui/fill-control';
import { Fill } from '../../shared/utils/fill';
import { usePieceDispatch } from '../../model/piece-context';
import { useSelectedLayer } from '../../selection/hooks/use-selected-layer';
import { LayerId, SobreimpresoContent } from '../../model/types';
import { SobreimpresoTextbox } from './types';
import { setSobreimpresoFill } from './accessors';

type Props = { s: SobreimpresoTextbox };

export const SobreimpresoFillControl: React.FC<Props> = ({ s }) => {
  const dispatch = usePieceDispatch();
  const layer = useSelectedLayer();
  const [fill, setFillState] = useState<Fill>({ kind: 'solid', color: '#000000' });

  useEffect(() => {
    if (layer?.kind !== 'sobreimpreso') return;
    setFillState(layer.content.fill);
  }, [layer]);

  const patch = (p: Partial<SobreimpresoContent>) => {
    const id = s.layerId as LayerId | undefined;
    if (id) dispatch({ type: 'patchLayerContent', id, patch: p });
  };

  // The accessor mutation is the live preview; commit records to the model.
  const preview = (v: Fill) => {
    setFillState(v);
    setSobreimpresoFill(s, v);
  };

  const commit = (v: Fill) => {
    preview(v);
    patch({ fill: v });
  };

  return <FillControl value={fill} onPreview={preview} onCommit={commit} />;
};
